<template>
	<div>
		<div v-if="notificationList.length!=0" class="table-responsive">
			<div style="text-align: center; width: 100%"></div>
			<table class="table">
				<thead>
					<tr>
						<th>&nbsp;</th>
						<th>Entity Type</th>
						<th class="link" v-on:click="sorting('entityid',$event)">
							Entity Id
							<i
								class="sort fa"
								:class="sort.field=='entityid'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th>Description</th>
						<th class="link" v-on:click="sorting('brand',$event)">
							Brand
							<i
								class="sort fa"
								:class="sort.field=='brand'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th class="link" v-on:click="sorting('vendor',$event)">
							Vendor
							<i
								class="sort fa"
								:class="sort.field=='vendor'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th>AlertType</th>
						<th class="link" v-on:click="sorting('createdon',$event)">
							Created On <i
								class="sort fa"
								:class="sort.field=='createdon'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"
							></i>
						</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in notificationList" :key="item.entityId">
						<td></td>
						<td>ASIN</td>
						<td>
							<!-- <span v-if="item.entitytype == 'ASIN'"> -->
								<a :href="'http://amazon.com/dp/' + item.entityid" target="_blank">{{item.entityid}}</a>
							<!-- </span> -->
							<!-- <span v-else>{{item.entityid}}</span> -->
						</td>
						<td style="width:40%">{{ item.description }}</td>
						<td>{{ item.brand }}</td>
						<td>{{ item.vendor }}</td>
						<td>ASIN Not Found</td>
						<td width = "10%">{{moment(item.createdon,"YYYY-MM-DD HH:mm:ss A").format('MM/DD/YYYY')}}</td>
						<td></td>
					</tr>
				</tbody>
			</table>
		</div>
		<NoDataAvailable displayMessage="No Data Is Available" v-else></NoDataAvailable>
	</div>
</template>

<script>
	import NoDataAvailable from "../NoDataAvailable.vue";
	var moment = require("moment");
	export default {
		name: "NotificationListGrid",
		data() {
			return {};
		},
		props: {
			notificationList: {
				type: Array
			}
		},
		mounted() {
			//console.log(this.notificationList);
		},
		computed: {
			sort: {
				set(val) {
					this.$store.commit("setSelectedSortOrder", val);
				},
				get() {
					return this.$store.state.selectedSortOrder;
				}
			}
		},
		components: {
			NoDataAvailable
		},
		methods: {
			moment,
			sorting(field, event) {
				if (
					event.currentTarget.children[0].classList[2] == "fa-arrow-up" ||
					event.currentTarget.children[0].classList[2] == "fa-arrow-down"
				) {
					var pastEvent = true;
				}
				for (
					var i = 0;
					i < document.getElementsByClassName("sort").length;
					i++
				) {
					document
						.getElementsByClassName("sort")
						[i].classList.remove("fa-arrow-up");
					document
						.getElementsByClassName("sort")
						[i].classList.remove("fa-arrow-down");
				}
				if (pastEvent) {
					this.sort.order == "desc"
						? event.currentTarget.children[0].classList.add(
								"fa-arrow-up"
						  )
						: event.currentTarget.children[0].classList.add(
								"fa-arrow-down"
						  );
					pastEvent = false;
				} else {
					event.currentTarget.children[0].classList.add("fa-arrow-up");
				}

				this.sort = {
					field: field,
					order:
						event.currentTarget.children[0].classList[2] ==
						"fa-arrow-up"
							? "asc"
							: "desc"
				};

				// this.$store.state.sort.field = field;
				// this.$store.state.sort.order = (event.currentTarget.children[0].classList[2]) == 'fa-angle-up' ? 'asc':'desc';
			}
		},

	};
</script>

<style lang="scss">
</style>
